namespace $.$$ {

	$mol_style_define( $bog_vmap_app_scenes, {
		position: 'relative',

		Tools: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1, basis: '6rem' },
		},

		Name: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1, basis: 0 },
		},

	} )

}
